<template>
    <div>
        <div class="one mt-3">
            <div class="form-floating">
                <input  type="text" class="form-control" id="floatingInput" :placeholder="$t('company.webtel_text_1')"
                        v-model="web" @input="webInput">
                <label for="floatingInput">{{ $t('company.webtel_text_1') }}</label>
            </div>
        </div>
        <div class="one mt-3">
            <div class="form-floating">
                <input  type="text" class="form-control" id="floatingInput" :placeholder="$t('company.webtel_text_2')"
                        v-model="tel" @keypress="onlyNumber">
                <label for="floatingInput">{{ $t('company.webtel_text_2') }}</label>
            </div>
        </div>
        <div class="check mt-3">
            <div class="form-group">
                <div class="d-flex align-items-center">
                    <input
                        v-model="isDph"
                        @click="changeDph"
                        type="checkbox" class="toggle" >
                    <label class="block mb-0 mt-1" @click="changeDph" style="cursor:pointer;">
                        {{ $t('company.webtel_text_3') }}
                    </label>
                    <div class="info">
                        <div class="my_tooltip"> 
                             {{ $t('company.webtel_text_4') }}
                        </div>
                        <div class="tooltip_hover info_icon">
                            <img src="/img/create_offer/info.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="text" v-show="isDph">
                <span>
                    {{ $t('company.webtel_text_5') }}
                </span>
                <input type="text" v-model="dph" @keypress="checkDph">
                <span>
                    {{ $t('company.webtel_text_6') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['company'],
        data() {
            return {
                web: "",
                tel: "",
                isDph: false,
                dph: 23,
                next: false,
            }
        },
        created () {
            this.web = this.company.web
            this.tel = this.company.tel
            if(this.company.dph){
                this.isDph = true
                this.dph = this.company.dph
            }
        },
        methods: {
            changeDph(){
                this.isDph = !this.isDph
            },
            checkDph(event){
                const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                if (!keysAllowed.includes(event.key) || this.dph.length > 2) {
                    event.preventDefault()
                }
            },
            onlyNumber (event) {
                const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '+', ' '];
                if (!keysAllowed.includes(event.key) || this.tel.length > 15) {
                    event.preventDefault()
                }
            },
            webInput(){
                var prefix = "https://"
                if(this.web != ""){
                    if(this.web.substring(0,prefix.length) != prefix){
                        this.web = prefix + this.web
                    }
                }
            },
            sendData(){
                let dph = this.dph
                if(!this.isDph)
                    dph = null
                let data = {
                    web: this.web,
                    tel: this.tel,
                    dph: dph
                }
                this.$emit('data', data);
            }
        },
        watch: {
            web: function(){
                this.sendData()
            },
            tel: function(){
                this.sendData()
            },  
            dph: function(){
                this.sendData()
            },
            isDph: function() {
                this.sendData()
            }
        },
        mounted () {
            $( ".tooltip_hover" ).hover(
                function() {
                    $( this ).parent().find('.my_tooltip').css('opacity', '1');
                },
                function() {
                    $( this ).parent().find('.my_tooltip').css('opacity', '0');
                },
            );
        },
    }
</script>

<style lang="scss" scoped>
    .one{
        .form-floating{
            width: 430px;
            height: 55px;
            margin: 0 auto;
            @media only screen and (max-width: 600px) {
                width: 95%;
            }
            input{
                display: flex !important;
                align-items: center !important;
                background: #FFFFFF;
                border: 1px solid #DDE3E8;
                box-sizing: border-box;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 16px;
                display: flex;
                align-items: center;
                color: #212541;
                padding-left: 23px;
            }
            label{
                display: flex !important;
                align-items: center !important;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 12px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #9598A7;
                padding-left: 23px;
            }
        }
    }
    .check{
        width: 430px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        @media only screen and (max-width: 600px) {
            width: 95%;
        }
        .form-group{
            display: flex;
            align-items: center;
            margin-bottom: 0px;
        }
        label{
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
        }
        input[type="checkbox"] {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            -webkit-tap-highlight-color: transparent;
            cursor: pointer;
            margin: 0px 10px 0 0px;
            background: #C7D4EB;
            border-radius: 25px;
        }
        .toggle{
            height: 22px;
            width: 40px;
            display: inline-block;
            position: relative;
            margin: 0;
            border: none;
            background: #FFFFFF;
            border-radius: 3px;
            transition: all 0.2s ease;
            &:focus {
                outline: 0;
            }
            &:after {
                content: "";
                position: absolute;
                top: 4px;
                left: 3px;
                width: 14px;
                height: 14px;
                border-radius: 50%;
                background: white;
                box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
                transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
            }
            &:checked {
                border-color: #2ED8B6;
                background: #2ED8B6;
            }
            &:checked:after {
                transform: translatex(20px);
                
            }
        }
        .info{
            position: relative;
            height: 20px;
            margin-left: 10px;
            .info_icon{
                pointer-events: all;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                float: right;
                img{
                    width: 80%;
                    height: 80%;
                }
            }
            .my_tooltip{
                bottom: 22px;
                right: -7px;
            }
        }
        .agree_tooltip{
            position: relative;
        }
        .my_tooltip{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 700;
            pointer-events: none;
            opacity: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 300px;
            background: #F3385A;
            box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
            border-radius: 6px;
            font-weight: 800;
            font-size: 14px;
            line-height: 18px;
            color: #fff;
            padding: 10px;
            position: absolute;
            top: unset;
            right: 15px;
            z-index: 10000;
            transition: opacity .5s ease-in-out;
            &::after{
                content: '';
                width: 15px;
                height: 15px;
                background: #F3385A;
                position: absolute;
                right: 10px;
                bottom: -3px;
                transform: rotate(45deg);
                border-radius: 3px;
            }
        }
        .form-check{
            margin-bottom: 0;
            .form-check-input{
                width: 16px !important;
                height: 16px !important;
                border-radius: 2px !important;
                outline: none !important;
                box-shadow: none !important;
            }
            .form-check-input:checked{
                background-color: #212541 !important;
                border: 1px solid #212541 !important;
            }
            label{
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;

                color: #212541;
            }
        }
        .text{
            margin-left: 35px;
            span{
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }
            input{
                text-align: center;
                width: 30px;
                border: none;
                background: transparent;
                border-bottom: 2px solid #212541;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }
        }
    }
</style>